// Toast-Benachrichtigung im einheitlichen Card-Stil (gleich wie UpdateBanner):
// abgerundete Card auf neutralem T.surface, Akzent nur über das Status-Icon
// (✓ grün / ! rot) — KEINE getönte Pille/Glow (feedback_no_pills_borders_glow).
// Positioniert wird sie vom gemeinsamen Notification-Stack in App.js (oben rechts).
//
// Konvention: message mit "!" am Anfang = Fehler (rotes Icon), sonst Erfolg.

import { useTheme } from '../context/ThemeContext';
import { F } from '../styles/theme';

export default function Toast({ message }) {
  const { T } = useTheme();
  if (!message) return null;

  const isError = message.startsWith('!');
  // Führendes ✓ entfernen — das Häkchen zeigt jetzt das Icon, nicht der Text.
  let text = isError ? message.slice(1) : message;
  text = text.replace(/^✓\s*/, '').trim();

  const accent = isError ? (T.red || '#E4544A') : (T.green || '#2ECC71');

  return (
    <>
      <style>{`
        @keyframes redToastIn {
          0%   { transform: translateY(-14px) scale(0.98); opacity: 0; }
          100% { transform: translateY(0) scale(1); opacity: 1; }
        }
      `}</style>

      <div
        key={text}
        role="status"
        aria-live="polite"
        style={{
          width: 350,
          maxWidth: 'calc(100vw - 28px)',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          padding: '13px 15px',
          background: T.surface,
          border: `1px solid ${T.line || T.border}`,
          borderRadius: 16,
          boxShadow: '0 14px 44px rgba(0,0,0,0.24)',
          animation: 'redToastIn 0.4s cubic-bezier(0.22, 1, 0.36, 1)',
        }}
      >
        {/* Status-Icon: Akzent nur über Stroke (kein getöntes Feld) */}
        <span style={{
          flexShrink: 0, width: 30, height: 30,
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          color: accent,
        }}>
          {isError ? (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7v6" />
              <path d="M12 16.5v.5" />
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="9" />
              <path d="M8.5 12.5l2.5 2.5 4.5-5" />
            </svg>
          )}
        </span>

        <div style={{
          minWidth: 0, fontSize: 13, fontWeight: 600, color: T.text,
          fontFamily: F.family, lineHeight: 1.35,
        }}>
          {text}
        </div>
      </div>
    </>
  );
}
